import File from '../Model/File'
import { getClosestElement, getElementChild, getTemplate } from '../Utility/Dom'
import { IS_DRAG } from '../Utility/State'

export default class FormFileService {
  private fileInputs: NodeListOf<HTMLInputElement>

  constructor () {
    this.fileInputs = document.querySelectorAll('[data-js=form-element][type=file]')
  }

  public init (): void {
    if (
      !window.File ||
      !window.FileList ||
      !window.FileReader
    ) {
      return
    }

    this.addEvents()
  }

  private addEvents (): void {
    this.fileInputs.forEach((fileInput): void => {
      fileInput.addEventListener('change', (e): void => this.onSelect(e, fileInput), false)
      fileInput.addEventListener('dragover', (e): void => this.onDrag(e), false)
      fileInput.addEventListener('dragleave', (e): void => this.onDrag(e), false)
      fileInput.addEventListener('drop', (e): void => this.onSelect(e, fileInput), false)
    })
  }

  private addFileInfos (file: File, fileList: HTMLElement): void {
    const fileTemplate = getTemplate('file-template')
    if (fileTemplate === null) {
      return
    }

    const fileInfo = getElementChild(fileTemplate, 'file-info')
    if (fileInfo === null) {
      return
    }

    const fileName = getElementChild(fileInfo, 'file-name')
    const fileSize = getElementChild(fileInfo, 'file-size')

    if (fileName !== null) {
      fileName.innerText = file.name
    }

    if (fileSize !== null) {
      fileSize.innerText = file.sizeFormated
    }

    fileList.appendChild(fileInfo)
  }

  private getAllowedMimeTypes (fileInput: HTMLInputElement): string[] {
    const accept = fileInput.getAttribute('accept')

    if (accept === null) {
      return []
    }

    return accept.split(',').map(type => type.trim())
  }

  private isValidFileType (file: File, allowedMimeTypes: string[]): boolean {
    return allowedMimeTypes.some((type: string): boolean => {
      return type.startsWith('.') ? file.name.endsWith(type) : file.type === type
    })
  }

  private onDrag (event: Event): void {
    const draggedElement = event.target as HTMLElement
    event.stopPropagation()
    event.preventDefault()

    if (event.type === 'dragover') {
      draggedElement.classList.add(IS_DRAG)
    } else {
      draggedElement.classList.remove(IS_DRAG)
    }
  }

  private onSelect (event, fileInput: HTMLInputElement): void {
    this.onDrag(event)
    let files = []

    if (event?.dataTransfer?.files) {
      event.target.files = event.dataTransfer.files
    }

    if (event.target.files) {
      files = event.target.files
    }

    if (files.length === 0) {
      return
    }

    files = [...files]

    const allowedMimeTypes = this.getAllowedMimeTypes(fileInput)
    if (allowedMimeTypes.length > 0) {
      const validFiles = files.filter((file) => this.isValidFileType(file, allowedMimeTypes))

      if (validFiles.length < files.length) {
        alert(fileInput.getAttribute('data-message-files-format') || 'Einige Dateien wurden entfernt, da ihr Format nicht unterstützt wird.')
      }

      if (validFiles.length === 0) {
        alert(fileInput.getAttribute('data-message-file-format') || 'Dateiformat wird nicht unterstützt.')
        return
      }

      const dataTransfer = new DataTransfer()
      validFiles.forEach((file) => dataTransfer.items.add(file))
      fileInput.files = dataTransfer.files
      files = validFiles
    }

    const formGroup = getClosestElement(event.target, 'form-group')
    const fileList = getElementChild(formGroup, 'file-list')

    if (fileList === null) {
      return
    }

    fileList.innerHTML = ''

    files.forEach((fileReference) => {
      const file = new File(fileReference)

      this.addFileInfos(file, fileList)
    })
  }
}
